import { render } from "./ExtendedSearch.vue?vue&type=template&id=1408fbb4"
import script from "./ExtendedSearch.vue?vue&type=script&lang=js"
export * from "./ExtendedSearch.vue?vue&type=script&lang=js"

import "./ExtendedSearch.vue?vue&type=style&index=0&id=1408fbb4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__